import { FC, useState } from 'react';
import { type Quiz } from '@teachur/http-client';
import { AttemptsList } from './AttemptsList';
import { ResetScoreModal } from './ResetScoreModal';

interface PreviousAttemptsProps {
  attempts: Quiz[];
  hideReset?: boolean;
}

export const PreviousAttempts: FC<PreviousAttemptsProps> = ({ attempts, hideReset = false }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onOpenModal = () => setIsModalOpen(true);
  const onCloseModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col gap-3 border border-(--neutral-black-NB100) justify-between rounded-xl bg-(--neutral-white-NW1000) p-4 shadow-md">
      <div className="flex flex-col gap-2 lg:flex-row lg:items-center lg:justify-between">
        <h3 className="[font-size:var(--fs-h7)]! text-(--neutral-black-NB800)! font-bold m-0!">
          Previous Attempts
        </h3>
        {!hideReset && (
          <button
            onClick={onOpenModal}
            className="text-(--neutral-white-NW700)! [font-family:var(--font-arvo)]! font-bold underline [font-size:var(--fs-b4)]! cursor-pointer disabled:opacity-50 self-start lg:self-auto"
          >
            Reset score
          </button>
        )}
      </div>
      <AttemptsList attempts={attempts} />
      <ResetScoreModal isOpen={isModalOpen} onClose={onCloseModal} />
    </div>
  );
};
